import { Box, Button, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import FactoryIcon from '@mui/icons-material/Factory';
import BusinessIcon from '@mui/icons-material/Business';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material';;


interface PageHeaderProps {
  manufacturer: any | null;
  onBack: () => void;
}

export function PageHeader({ manufacturer, onBack }: PageHeaderProps) {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 3 }}>
      <Button onClick={onBack} sx={{ minWidth: 0, p: 0, mr: 1, color: '#23272E', fontSize: 22 }}>
        <ArrowBackIosNewIcon />
      </Button>
      <Box sx={{ 
        width: 80, 
        height: 80, 
        borderRadius: 2, 
        backgroundColor: theme.palette.primary.main, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <FactoryIcon sx={{ fontSize: 40, color: 'white' }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="h4" fontWeight={800} color={theme.palette.text.primary} mb={1}>
          {manufacturer.name}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <Chip 
            label="Fabricante" 
            color="primary"
            size="small"
            variant="outlined"
          />
          {manufacturer.tenant_name && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <BusinessIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
              <Typography color={theme.palette.text.secondary} fontSize={14}>
                {manufacturer.tenant_name}
              </Typography>
            </Box>
          )}
        </Box>
        <Typography color={theme.palette.text.secondary} fontSize={14}>
          {manufacturer.description}
        </Typography>
      </Box>
    </Box>
  );
} 